import $ from "jquery";
import "popper.js"; // Bootstrap requires this
import "bootstrap";
import "fslightbox";
import "slick-carousel";
import AOS from 'aos';
// Can import modules as needed
// ex. import 'bootstrap/js/dist/dropdown';


// import "./scss/style.scss"; // This is now being imported in the webpack.config file 

// This is for slick carousels
global.jQuery = global.$ = require('jquery');

// # ---------------------------------------------------------------
// # Custom Methods...
(function ($) {
	$(function () {
		console.log("Document Ready");

		// Add class to header when mobile nav is open
		$('.navbar-toggler').click(function () {
			$('header#site-header').toggleClass('nav-open');
			$('body').toggleClass('overflow-hidden');
		});

		let tbHeight = 0;
		let abHeight = 0;

		if ($('.top-bar').length > 0) {
			tbHeight = $('.top-bar.setting-sticky').height();
		}
		if ($('.alert-bar').length > 0) {
			abHeight = $('.alert-bar.setting-sticky').height();
		}

		// Reposition site nav if sticky and top bar is on
		if ($('#site-header').hasClass('setting-sticky')) {
			if ($('.top-bar').length > 0) {
				let headerOffset = $('#site-header.setting-sticky').offset().top + tbHeight;
				$('#site-header.setting-sticky').css('top', headerOffset);
			}
			if ($('.alert-bar').length > 0) {
				let alertBarOffset = $('#site-header.setting-sticky').offset().top + tbHeight + $('#site-header').height();
				$('.alert-bar.setting-sticky').css('top', alertBarOffset);
			}
			spaceForNav();
		}

		// Add top padding to main content if using sticky header
		function spaceForNav() {
			if ($('#site-header').hasClass('setting-sticky')) {

				let tbHeight = 0;
				let abHeight = 0;

				if ($('.top-bar').length > 0) {
					tbHeight = $('.top-bar.setting-sticky').height();
				}
				if ($('.alert-bar').length > 0) {
					abHeight = $('.alert-bar.setting-sticky').height();
				}

				let mainPt = $('#site-header.setting-sticky').height() + abHeight + tbHeight;
				console.log(mainPt);
				$('main.page-content').css('padding-top', mainPt + 'px'); // TODO find out why there is a gap here
			}
		}

		$(window).resize(function () {
			spaceForNav();
		});



		// Hide Header on on scroll down
		var delta, didScroll, hasScrolled, lastScrollTop, navbarHeight;
		didScroll = void 0;
		lastScrollTop = 0;
		delta = 5;
		navbarHeight = $('header#site-header').outerHeight();

		hasScrolled = function () {
			var st;
			st = $(window).scrollTop();
			if (Math.abs(lastScrollTop - st) <= delta) {
				return;
			}
			// If they scrolled down and are past the navbar, add class .nav-up.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > navbarHeight) {
				// Scroll Down
				$('#site-header.setting-sticky').removeClass('nav-down').addClass('nav-up');
				$('.top-bar').removeClass('nav-down').addClass('nav-up');
				$('.alert-bar').removeClass('nav-down').addClass('nav-up');


			} else {
				//Scroll Up
				if (st + $(window).height() < $(document).height()) {
					$('#site-header.setting-sticky').removeClass('nav-up').addClass('nav-down');
					$('.top-bar').removeClass('nav-up').addClass('nav-down');
					$('.alert-bar').removeClass('nav-up').addClass('nav-down');
				}
			}
			lastScrollTop = st;
		};

		$(window).scroll(function (event) {
			didScroll = true;
		});

		setInterval((function () {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}), 150);

		// Slick sliders
		$(function () {

			$('.slick-image-gallery').each(function () {
				let $this = $(this);
				let prev_icon = $this.attr('data-icon-prev');
				let next_icon = $this.attr('data-icon-next');
				let columns = $this.attr('data-columns');

				$this.slick({
					slidesToShow: columns,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					dots: true,
					autoplay: true,
					prevArrow:
						'<a class="slick-prev"><i class="bi ' + prev_icon + '"></i></a>',
					nextArrow:
						'<a class="slick-next"><i class="bi ' + next_icon + '"></i></i></a>',

					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 3,
							}
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 1,
							}
						},
					],
				});
			});

		});

		// Fix for cloned images opening on attachment page
		$('.slick-image-gallery').on('afterChange', function () {
			refreshFsLightbox();
		});

		//----------------------
		// Recalculate height for Masonry layout
		//----------------------

		// Calculate masonry height on initial load
		const masonry = $('.js-flex-masonry');
		recalculateMasonryHeight();

		function recalculateMasonryHeight() {

			if (masonry) {


				// TODO: Need to dynamically calculate height based on number of columns selected

				//let counter = 0;

				// $('.post-card-wrap').each(function (){
				//     $(this).html(counter);
				//     counter++;
				// });

				let mobileHeight = 0;
				let col1height = 0;
				let col2height = 0;
				let col3height = 0;
				let margin = 20;

				let windowWidth = $(window).width();

				if (windowWidth < 1400) {
					margin = 20;
				} else {
					margin = 40;
				}

				// 1st Col
				$('.masonry-item:nth-child(3n+1)').each(function () {
					//$(this).children('.post-card').css('background-color', 'blue');
					col1height += ($(this).outerHeight() + margin);
					mobileHeight += ($(this).outerHeight() + margin - 4);
				});
				// 2nd Col
				$('.masonry-item:nth-child(3n+2)').each(function () {
					//$(this).children('.post-card').css('background-color', 'red');
					col2height += ($(this).outerHeight() + margin);
					mobileHeight += ($(this).outerHeight() + margin - 4);
				});
				// 3rd Col
				$('.masonry-item:nth-child(3n)').each(function () {
					//$(this).children('.post-card').css('background-color', 'green');
					col3height += ($(this).outerHeight() + margin);
					mobileHeight += ($(this).outerHeight() + margin - 4);
				});

				let tallestCol = Math.max(col1height, col2height, col3height) + 40;

				if (windowWidth < 600) {
					$('.js-flex-masonry').css('height', mobileHeight + 'px');
				} else {
					$('.js-flex-masonry').css('height', tallestCol + 'px');
				}
			}
		}

		$(window).resize(recalculateMasonryHeight).trigger('resize');

		// ---


		// Initialize AOS
		AOS.init();

		// Fix bug with some animations not firing on scroll
		window.addEventListener('load', AOS.refresh);


	});
})($);
